import { useEffect, useRef, useState } from "react";
import logoImg from 'assets/images/ssgk/ssgk-logo.png';
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
export const SchoolHeader = () => {
      const [isScrolled, setIsScrolled] = useState(false);
      const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
      const [exploreOpen, setExploreOpen] = useState(false);
      const [mobileExploreOpen, setMobileExploreOpen] = useState(false);
      const exploreRef = useRef(null);
      const mobileExploreRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
          if (exploreRef.current && !exploreRef.current.contains(event.target)) {
            setExploreOpen(false);
          }
          if (mobileExploreRef.current && !mobileExploreRef.current.contains(event.target)) {
            setMobileExploreOpen(false);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    return (<header
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled
            ? "bg-white/95 backdrop-blur-sm shadow-md"
            : "bg-transparent"
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            <img src={logoImg} alt="School Logo" className="h-10"  onClick={() => window.location.href = '/home'} />
          <nav className="hidden md:flex items-center space-x-6 ">
          {localStorage?.getItem('user') ? (
            <>
              <a
                className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
                href="/user/alumini"
                aria-label="Find Alumni"
              >
                Find Alumni
              </a>
              <a
                className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
                href="/user/gatepass"
                aria-label="Request Visit Pass"
              >
                Request Visit Pass
              </a>
              <a
                className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
                href="/user/icard"
                aria-label="Identity Card"
              >
                Identity Card
              </a>
              <a
                className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
                href="/user/myProfile"
                aria-label="My Profile"
              >
                My Profile
              </a>
              <button
                type="button"
                className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
                onClick={() => {
                  localStorage.clear();
                  getAuth()
                    .signOut()
                    .then(() => (window.location.href = '/pages/authentication/sign-in'))
                    .catch((error) => console.error('Logout error:', error));
                }}
                aria-label="Logout"
              >
                Logout
              </button>
            </>
          ) : (
            <a
              className="relative px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              href="/pages/authentication/sign-in"
              aria-label="Login"
            >
              Login
            </a>
          )}
          </nav>







          <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-blue-800 focus:outline-none"
            >
              <i
                className={`fas ${
                  mobileMenuOpen ? "fa-times" : "fa-bars"
                } text-2xl`}
              ></i>
            </button>
          </div>
        </div>
        <div className={`md:hidden ${mobileMenuOpen ? "block" : "hidden"}`}>
        <div className="px-4 pt-2 pb-4 bg-white/95 backdrop-blur-sm space-y-2 flex flex-col items-center justify-center">
        {localStorage?.getItem('user') ? (
          <>
            <a
              className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              href="/user/alumini"
              aria-label="Find Alumni"
            >
              Find Alumni
            </a>
            <a
              className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              href="/user/gatepass"
              aria-label="Request Visit Pass"
            >
              Request Visit Pass
            </a>
            <a
              className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              href="/user/icard"
              aria-label="Identity Card"
            >
              Identity Card
            </a>
            <a
              className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              href="/user/myProfile"
              aria-label="My Profile"
            >
              My Profile
            </a>
            <button
              type="button"
              className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
              onClick={() => {
                localStorage.clear();
                getAuth()
                  .signOut()
                  .then(() => (window.location.href = '/login'))
                  .catch((error) => console.error('Logout error:', error));
              }}
              aria-label="Logout"
            >
              Logout
            </button>
          </>
        ) : (
          <a
            className="w-full text-center px-4 py-2 rounded-md text-sm font-medium text-gray-700 hover:text-blue-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition"
            href="/login"
            aria-label="Login"
          >
            Login
          </a>
        )}
            </div>

        </div>
      </header >)}